const KEY_DISPLAY_NAME = 'autodj.display_name';
const KEY_TIP_INFO = 'autodj.has_seen_tip_info';
const KEY_LAST_SUGGESTION_AT = 'autodj.last_suggestion_at';
const KEY_HISTORY = 'autodj.history';

const HISTORY_LIMIT = 20;

export const SUGGESTION_COOLDOWN_MS = 30_000;
export const MAX_ACTIVE_SUGGESTIONS_PER_CLIENT = 3;

function safeGet(key) {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeSet(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch {
    // ignore quota / private mode
  }
}

export function getDisplayName() {
  const raw = safeGet(KEY_DISPLAY_NAME);
  return raw ? raw.slice(0, 32) : null;
}

export function setDisplayName(name) {
  const clean = (name ?? '').trim().slice(0, 32);
  if (clean.length < 1) return false;
  safeSet(KEY_DISPLAY_NAME, clean);
  return true;
}

export function hasSeenTipInfo() {
  return safeGet(KEY_TIP_INFO) === '1';
}

export function markTipInfoSeen() {
  safeSet(KEY_TIP_INFO, '1');
}

export function getLastSuggestionAt() {
  const v = safeGet(KEY_LAST_SUGGESTION_AT);
  if (!v) return 0;
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

export function markSuggestionSent() {
  safeSet(KEY_LAST_SUGGESTION_AT, String(Date.now()));
}

export function getCooldownRemainingMs() {
  const last = getLastSuggestionAt();
  if (!last) return 0;
  return Math.max(0, SUGGESTION_COOLDOWN_MS - (Date.now() - last));
}

export function getHistory() {
  try {
    const raw = safeGet(KEY_HISTORY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function pushHistoryEntry(entry) {
  const next = [
    { at: Date.now(), ...entry },
    ...getHistory().filter((e) => e?.id !== entry?.id),
  ].slice(0, HISTORY_LIMIT);
  safeSet(KEY_HISTORY, JSON.stringify(next));
  return next;
}
